import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchExplainPlan = (cleanRoomID, cleanRoomQuestionID, runID) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  return useQuery(
    ['ExplainPlan', { cleanRoomID, cleanRoomQuestionID, runID }],
    () => axiosInstance.get(
      cleanRoom(orgId).getExplainPlan(cleanRoomID, cleanRoomQuestionID, runID)),
    {
      enabled: !!cleanRoomID && !!cleanRoomQuestionID && !!runID,
      select: (res) => res?.data || {},
      onError: (err) => dispatch(showAlert({ message: err?.response?.data?.message || 'Something went wrong', type: 'error' })),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};
